/**
 * Подписи к осям разбора картинок (категория и форма подачи).
 *
 * Модель возвращает их латинскими слагами из закрытого списка (см. серверный
 * common/vision.py): ключ обязан быть стабильным, иначе одна и та же категория
 * в разных языках стала бы разными строками таблицы. Поэтому переводим только на
 * экране. Незнакомый слаг (список у модели пополняется) не прячем и не ломаем —
 * показываем как есть, заменив подчёркивания пробелами.
 */

const CATEGORY_KEYS = {
  people: "CM_IMG_CAT_PEOPLE",
  food_drink: "CM_IMG_CAT_FOOD_DRINK",
  fashion_beauty: "CM_IMG_CAT_FASHION_BEAUTY",
  sports_fitness: "CM_IMG_CAT_SPORTS_FITNESS",
  travel_places: "CM_IMG_CAT_TRAVEL_PLACES",
  nature_animals: "CM_IMG_CAT_NATURE_ANIMALS",
  home_interior: "CM_IMG_CAT_HOME_INTERIOR",
  technology: "CM_IMG_CAT_TECHNOLOGY",
  automotive: "CM_IMG_CAT_AUTOMOTIVE",
  business_work: "CM_IMG_CAT_BUSINESS_WORK",
  education: "CM_IMG_CAT_EDUCATION",
  health_medicine: "CM_IMG_CAT_HEALTH_MEDICINE",
  art_design: "CM_IMG_CAT_ART_DESIGN",
  music: "CM_IMG_CAT_MUSIC",
  entertainment: "CM_IMG_CAT_ENTERTAINMENT",
  shopping_product: "CM_IMG_CAT_SHOPPING_PRODUCT",
  finance: "CM_IMG_CAT_FINANCE",
  kids_family: "CM_IMG_CAT_KIDS_FAMILY",
  event_holiday: "CM_IMG_CAT_EVENT_HOLIDAY",
  text_graphic: "CM_IMG_CAT_TEXT_GRAPHIC",
  other: "CM_IMG_OTHER",
};

const CONTENT_TYPE_KEYS = {
  photo: "CM_IMG_TYPE_PHOTO",
  illustration: "CM_IMG_TYPE_ILLUSTRATION",
  collage: "CM_IMG_TYPE_COLLAGE",
  screenshot: "CM_IMG_TYPE_SCREENSHOT",
  infographic: "CM_IMG_TYPE_INFOGRAPHIC",
  ad_creative: "CM_IMG_TYPE_AD_CREATIVE",
  meme: "CM_IMG_TYPE_MEME",
  other: "CM_IMG_OTHER",
};

const MAPS = { category: CATEGORY_KEYS, content_type: CONTENT_TYPE_KEYS };

/** 'food_drink' → «Еда и напитки»; незнакомый слаг → 'food drink'. */
export function imageFacetLabel(termType, slug, t) {
  const map = MAPS[termType];
  const key = map && map[slug];
  if (key) return t(key);
  return String(slug || "").replace(/_/g, " ");
}

/** Бренды и прочее переводить нечего — только категории и формы подачи. */
export function isTranslatableFacet(termType) {
  return !!MAPS[termType];
}

export default { imageFacetLabel, isTranslatableFacet };
